import { InspectionDecisionsEnum } from '../enums/InspectionDecisionsEnum';
import { IInspectionDecisionSelectOption } from '../interfaces/IInspectionDecisionSelectOption';

export const approvedPlanInspectionDecisionOption: IInspectionDecisionSelectOption = {
  id: InspectionDecisionsEnum.APPROVED,
  label: 'Согласовано',
  value: true,
};

export const inspectionDecisionOptions: IInspectionDecisionSelectOption[] = [
  approvedPlanInspectionDecisionOption,
  {
    id: InspectionDecisionsEnum.DECLINED,
    label: 'Отказано',
    value: false,
  },
];
